import { createRoot } from "react-dom/client";
import React from "react";
import "./assets/styles/app.css";
import Root from "./pages";
import store from "./configs/store";
import configureRequest from "./configs/request";
import "./configs/icons";
import "./configs/i18n";

configureRequest();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById("root")!;

const root = createRoot(container);
root.render(<Root store={store} />);
